<template>
  <div class="mb-20">
    <h1 class="pl-2 md:pl-0 text-3xl uppercase my-20" :class="fontThin()">{{ $t("footer.about") }}</h1>
    <div v-if="currentPage">
      <vue-editor v-model="currentPage.body" :disabled="true" />
    </div>
    <div v-else>
      Still no content in this page
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { mapGetters } from 'vuex';
import PagesMixin from '@/mixins/PagesMixin';

export default {
  metaInfo() {
    const description = this.$t('metaDescriptions.about');
    return {
      meta: [
        {
          name: 'description',
          content: description,
        },
      ],
    };
  },

  data() {
    return {
      currentPage: {},
    };
  },

  components: {
    VueEditor,
  },

  computed: {
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
    }),
  },

  watch: {
    changedLocale() {
      this.getPage();
    },
  },

  mounted() {
    this.getPage();
  },

  mixins: [PagesMixin],

  methods: {
    getPage() {
      this.getCurrentPage('abt').then(({ data }) => {
        this.currentPage = data;
      }).catch(() => {
        this.createNotification('error', `${this.$t('notifications.errorReload')}`);
      });
    },
  },

};
</script>
